import VocabularyManagerIcon from '../../core/icons/VocabularyManager';
import OntologyManagerIcon from '../../core/icons/OntologyManager';
import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';
import SearchSelect from '../../core/SearchSelect';
import LanguageSelector from '../LanguageSelector';
import GS from '../../grafsync/grafsync';
import { getGraphFromProject, makeCancelable } from '../utils/utils';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import TitledPanel from '../TitledPanel';
import CreateButton from '../CreateButton';
import { globalStyles as styles } from '../style/gstheme';

class SelectProjectDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: props.open,
            hideIfOpen: props.open,
            lang: "en",
            langs: []
        };
        this.cancellable = null;
        this.cancellable1 = null;
    }

    changeLanguage = (lang) => this.setState({ lang });

    doGetLanguages = () => {
        this.cancellable1 = makeCancelable(GS.getProjectLanguages());
        return this.cancellable1;
    };

    componentDidMount() {
        this.doGetLanguages().promise
            .then(langs => {
                if (this.cancellable1 && this.cancellable1.isCancelled()) return;
                this.setState({ langs, isLoadingLanguages: false, lang: langs && langs.length > 0 ? langs[0].lang : "en" });
            })
            .catch((e) => {
                if (this.cancellable1 && !this.cancellable1.isCancelled()) this.setState({ isErrored: e });
            });
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
        if (this.cancellable1) this.cancellable1.cancel();
    }

    handleClickOpen = () => this.setState({ open: true });

    computeSearch = (value, lang) => {
        let fullSearch =
        {
            search: [
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: [
                        "https://grafsync.graphifi.com/schema/gs/TaxonomyProject",
                        "https://grafsync.graphifi.com/schema/gs/OntologyProject"
                    ]
                },
                {
                    predicate: "https://grafsync.graphifi.com/schema/gs/isVersionOfProject",
                    invert: true
                },
                {
                    predicate: "https://grafsync.graphifi.com/schema/gs/defaultLang",
                    value: lang,
                    isExactMatch: true
                },
                {
                    predicate: "http://purl.org/dc/terms/title",
                    value: value,
                    isExactMatch: false
                }
            ],
            exclude: this.props.exclude,
            language: lang,
            searchMode: "Compliant",
            sort: ["http://purl.org/dc/terms/title"],
            pageSize: 100,
            predicates: ["http://purl.org/dc/terms/title", 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type']
        };
        return fullSearch;
    };

    addProject = (id, resourceType) => {
        this.props.onAddProject(id, this.state.lang, resourceType);
        this.exitAddProject();
    };

    exitAddProject = () => this.setState({ open: false, hideIfOpen: false });

    render() {

        const { classes, label, includeIcon, disabled, dataTest } = this.props;
        const { langs, lang, hideIfOpen } = this.state;
        const langList = langs ? langs.map(langItem => langItem.lang) : [];

        return (
            <React.Fragment>
                {!hideIfOpen && <CreateButton
                    disabled={disabled}
                    dataTest={dataTest}
                    includeIcon={includeIcon}
                    onClick={() => this.handleClickOpen()} label={label} />}
                <Dialog
                    maxWidth="md"
                    data-test="add-project-dialog"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.smallDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open} onClose={this.exitFindResource} aria-labelledby="find-project-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-project-dialog-title">{label}</DialogTitle>
                    <DialogContent style={{ height: 460, overflow: 'scroll' }}>
                        <TitledPanel dataTest="project-language" title="Language">
                            <LanguageSelector
                                key={langList.length}
                                includeLabel={false}
                                langs={langList}
                                onSelect={this.changeLanguage}
                                defaultLang={lang} />
                        </TitledPanel>
                        <div style={{ height: 360 }}>
                            <SearchSelect
                                key={lang}
                                dataTest="find-project"
                                focus={true}
                                sortProp="title"
                                wrapped={true}
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listDisplay={(result, lang) => {
                                    if (result.title[lang]) {
                                        return <div>
                                            <Typography data-test="result-label" variant="body2" style={{ textIndent: '-1.3em', marginLeft: '2.4em' }}>
                                                <Tooltip placement="left" title={result.type === "TaxonomyProject" ?
                                                    "Taxonomy project"
                                                    :
                                                    "Ontology project"
                                                }>
                                                    <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
                                                        {result.type === "TaxonomyProject" ?
                                                            <VocabularyManagerIcon color="primary" />
                                                            :
                                                            <OntologyManagerIcon color="primary" />
                                                        }
                                                    </span>
                                                </Tooltip>
                                                <span data-test={result.type + "-entry"}>
                                                    <Tooltip placement="left" title={result.id}>
                                                        <span style={{ marginLeft: 12 }}>
                                                            {result.title[lang]}
                                                        </span>
                                                    </Tooltip>
                                                </span>
                                            </Typography>
                                            {GS.isGraphLocked(getGraphFromProject(result.id)) && <Typography data-test="locked" variant="caption">Locked</Typography>}
                                        </div>;
                                    }
                                    else {
                                        return <Typography data-test="result-label" variant="body2">{result.id}</Typography>;
                                    }
                                }}
                                isClickableResult={(result) => {
                                    const isGraphLocked = GS.isGraphLocked(getGraphFromProject(result.id));
                                    if (isGraphLocked) return false;
                                    if (result.invalid) return false;
                                    return true;
                                }}
                                title="Filter projects"
                                lang={lang}
                                chosen={this.addProject} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddProject} />
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

SelectProjectDialog.defaultProps = {
    exclude: [],
    label: 'Add Project',
    includeIcon: true,
    disabled: false,
    dataTest: "add-project",
    open: false
};

SelectProjectDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    dataText: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    exclude: PropTypes.array,
    includeIcon: PropTypes.bool,
    onAddProject: PropTypes.func.isRequired
};

export default withStyles(styles)(SelectProjectDialog);